export default __webpack_public_path__ + "static/media/Moon18_White.c5100565.png";